module.exports = __webpack_public_path__ + "static/img/classificacao-sentimento.ef3a723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/classificacao-sentimento.png
// module id = G/we
// module chunks = 1